import { useEffect } from "react";
import useGlobalStore from "../../../store/global.store";
import { useRemote } from "../../../hooks/useRemote";

const VipSubCheck = () => {
  const hasVipAddOn = useGlobalStore((state) => state.hasVipAddOn);
  const resetVip = useGlobalStore((state) => state.resetVip);
  const { updateView } = useRemote();

  useEffect(() => {
    console.log("hasVipAddOn", hasVipAddOn);
    if (!hasVipAddOn) {
      resetVip();
      updateView("Home");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasVipAddOn]);

  return <div></div>;
};

export default VipSubCheck;
